import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';
import { UpdateInvestigationPriorityCommand } from './update-investigation-priority.command';

@Injectable({ providedIn: 'root' })
export class UpdateInvestigationPriorityUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(command: UpdateInvestigationPriorityCommand): Observable<void> {
    this._state.setSavingPriority(true);

    return this._repository.updatePriority(command.investigationId, command.priorityCode).pipe(
      tap(() => {
        this._state.setSavingPriority(false);
      }),
      catchError((error) => {
        this._state.setSavingPriority(false);
        return throwError(() => error);
      }),
    );
  }
}
